// src/admin/components/Sidebar.jsx
import React from "react";
import { Link } from "react-router-dom";
import "./Sidebar.css"; // Import CSS file

const Sidebar = ({ isOpen, closeSidebar }) => {
  const role = localStorage.getItem("adminRole");
  const permissions = JSON.parse(localStorage.getItem("adminPermissions") || "[]");

  const hasPermission = (moduleName) => {
    if (role === "admin") return true;
    // Check if user has either read or write permission for this module
    return permissions.includes(`${moduleName}:read`) || permissions.includes(`${moduleName}:write`);
  };

  return (
    <div className={`admin-sidebar ${isOpen ? "open" : ""}`}>
      <div className="sidebar-header">
        <div className="sidebar-logo-container">
          <img src="/Images/nbitez_logo.jpeg" alt="Logo" className="sidebar-logo-img" />
          <h2 className="sidebar-title">Nbitez</h2>
        </div>
      </div>
      <ul className="sidebar-menu">
        {hasPermission("Dashboard") && (
          <li><Link onClick={closeSidebar} to="/adminDashboard"><span className="icon">🏠</span> Dashboard</Link></li>
        )}
        {hasPermission("Users") && (
          <li><Link onClick={closeSidebar} to="/adminDashboard/users"><span className="icon">👥</span> Users</Link></li>
        )}
        {hasPermission("Products") && (
          <li><Link onClick={closeSidebar} to="/adminDashboard/products"><span className="icon">📦</span> Products</Link></li>
        )}
        {hasPermission("Categories") && (
          <li><Link onClick={closeSidebar} to="/adminDashboard/categories"><span className="icon">📂</span> Categories</Link></li>
        )}
        {hasPermission("Orders") && (
          <li><Link onClick={closeSidebar} to="/adminDashboard/order"><span className="icon">🛒</span> Orders</Link></li>
        )}
        {hasPermission("Banners") && (
          <li><Link onClick={closeSidebar} to="/adminDashboard/banners"><span className="icon">🖼️</span> Banners</Link></li>
        )}
        {hasPermission("Blogs") && (
          <li><Link onClick={closeSidebar} to="/adminDashboard/blogs"><span className="icon">📝</span> Blogs</Link></li>
        )}
        {hasPermission("Shipping") && (
          <li><Link onClick={closeSidebar} to="/adminDashboard/shipping-fees"><span className="icon">🚚</span> Shipping</Link></li>
        )}
        {hasPermission("Wallet") && (
          <li><Link onClick={closeSidebar} to="/adminDashboard/wallet"><span className="icon">💰</span> Wallet</Link></li>
        )}
        {role === "admin" && (
          <li><Link onClick={closeSidebar} to="/adminDashboard/subadmins"><span className="icon">🛡️</span> Sub-Admins</Link></li>
        )}
        {hasPermission("Contacts") && (
          <li><Link onClick={closeSidebar} to="/adminDashboard/contacts"><span className="icon">✉️</span> Contacts</Link></li>
        )}
        {hasPermission("Settings") && (
          <li><Link onClick={closeSidebar} to="/adminDashboard/settings"><span className="icon">⚙️</span> Settings</Link></li>
        )}
      </ul>
    </div>
  );
};

export default Sidebar;
